module.exports = __webpack_public_path__ + "static/media/slzhitui-fuwu-3.a333efa9.png";